import { cn } from "@/utils/cn";
import { CornerDownRight, Loader2 } from "lucide-react";
import { useProgressEllipses } from "../hooks/useProgressEllipses";

export const ThinkingIndicator = ({
  text = "Thinking",
  className = "",
}: {
  text?: string;
  className?: string;
}) => {
  const ellipses = useProgressEllipses();

  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <Loader2 className="h-3 w-3 animate-spin text-zinc-400" />
      <span className="text-xs text-zinc-400">
        {text}
        {ellipses}
      </span>
    </div>
  );
};

/**
 * Placeholder for prose that hasn't arrived yet: tinted bars the height of a
 * text line, with a slow shimmer. Sits where the paragraph will render so the
 * layout doesn't jump when the first tokens land.
 */
export const ResponseSkeleton = ({
  lines = 3,
  label = "Responding",
  className = "",
}: {
  lines?: number;
  label?: string;
  className?: string;
}) => {
  // Ragged right edge like a real paragraph; the last line is always short.
  const widths = ["96%", "88%", "92%", "84%"];
  return (
    <div
      role="status"
      aria-label={label}
      className={cn("max-w-2xl text-zinc-900", className)}
    >
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="flex h-7 items-center">
          <div
            className="text-skeleton-bar"
            style={{
              width: i === lines - 1 ? "58%" : widths[i % widths.length],
              animationDelay: `${i * 120}ms`,
              borderRadius: "2px",
            }}
          />
        </div>
      ))}
    </div>
  );
};

export const ToolCallRunningIndicator = () => {
  const ellipses = useProgressEllipses();
  return (
    <div className="flex items-center gap-1.5 ml-5 mt-0.5">
      <CornerDownRight className="h-3 w-3 shrink-0 text-zinc-300" />
      <span className="text-xs text-zinc-400 italic">
        running{ellipses}
      </span>
    </div>
  );
};
